// extracted by mini-css-extract-plugin
export default {"canvas":"DarkGlowTracker_canvas__o1g0i"};